import { Model } from 'miragejs';

// Mirage-only Model
// Helps simulate the response from querying the channel list from the Teams integration.
// This model is payload only; it is not consumed by Ember Data.

export default Model.extend({});
